import axios from '@/plugins/axios.js';
import EdverumTable from '@/store/utilities/EdverumTable.js';
import { sortAlphabetically } from '@/utilities/sort.js';

const collectionHelpers = EdverumTable.collection('Group');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.created.state,

        categories: [],
        loadingCategories: false,
        savingCategory: false,
        searchCategory: null,
    },

    getters: {
        ...EdverumTable.search.getters,

        categoriesLoaded(state) {
            return state.categories.length && !state.loadingCategories;
        },

        hasCategorySearch(state) {
            return state.searchCategory && state.searchCategory.toString().length;
        },

        searchCategory(state) {
            return state.searchCategory;
        },
    },
    actions: {
        ...EdverumTable.created.actions,

        async fetchCategories(context) {
            context.commit('TOGGLE_LOADING_CATEGORIES');

            const { data } = await axios.get('/api/group-categories?sort=name&per_page=1000');

            context.commit('TOGGLE_LOADING_CATEGORIES');

            context.commit('SET_CATEGORIES', data.data);
        },

        async addNewCategory({ commit }, name) {
            commit('TOGGLE_SAVING_CATEGORY');

            try {
                const { data } = await axios.post('/api/group-categories', {
                    name,
                });

                commit('ADD_CATEGORY', data.data);

                return data.data;
            } finally {
                commit('TOGGLE_SAVING_CATEGORY');
            }
        },
        reset: collectionHelpers.actions.reset('Groups'),
    },
    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.created.mutations,

        SET_CATEGORIES(state, categories) {
            state.categories = sortAlphabetically(categories);
        },
        ADD_CATEGORY(state, category) {
            state.categories = sortAlphabetically([...state.categories, category]);
        },
        TOGGLE_LOADING_CATEGORIES(state) {
            state.loadingCategories = !state.loadingCategories;
        },
        TOGGLE_SAVING_CATEGORY(state) {
            state.savingCategory = !state.savingCategory;
        },
        SET_SEARCH_CATEGORY(state, category) {
            state.searchCategory = category;
        },
    },
};
